export const NotFoundPage = () => {
  return <>Page not found</>;
};
